export default "__VITE_ASSET__CUbw6sf4__"